import { buildXrhubAppRedirectUrl } from "./xrhubRedirect.js";

function normalizeRouterBasePath(routerBasePath) {
  const normalizedBasePath = String(routerBasePath || "")
    .trim()
    .replace(/\/+$/, "");

  if (!normalizedBasePath || normalizedBasePath === "/") {
    return "";
  }

  return normalizedBasePath.startsWith("/") ? normalizedBasePath : `/${normalizedBasePath}`;
}

function normalizeRelativeAppPath(pathname) {
  const normalizedPath = String(pathname || "/").trim() || "/";
  return normalizedPath.startsWith("/") ? normalizedPath : `/${normalizedPath}`;
}

export function buildEditorDefaultPagePath(defaultPagePath, { routerBasePath } = {}) {
  const basePath = normalizeRouterBasePath(routerBasePath);
  const relativePath = normalizeRelativeAppPath(defaultPagePath || "/");

  return basePath ? `${basePath}${relativePath}` : relativePath;
}

export function resolveEditorTermsUrl({ brandingTermsUrl, xrhubUrl, locationOrigin } = {}) {
  if (brandingTermsUrl) {
    return brandingTermsUrl;
  }

  return buildXrhubAppRedirectUrl("/terms", {
    xrhubUrl,
    locationOrigin
  });
}

export function resolveEditorProjectsUrl({ xrhubUrl, locationOrigin } = {}) {
  return buildXrhubAppRedirectUrl("/projects", {
    xrhubUrl,
    locationOrigin
  });
}

export function resolveEditorPricingUrl({ pricingPageUrl, xrhubUrl, locationOrigin } = {}) {
  if (pricingPageUrl) {
    return pricingPageUrl;
  }

  return buildXrhubAppRedirectUrl("/tiers", {
    xrhubUrl,
    locationOrigin
  });
}
